import { render, staticRenderFns } from "./daochuMonth.vue?vue&type=template&id=5d0a978c&scoped=true&"
import script from "./daochuMonth.vue?vue&type=script&lang=js&"
export * from "./daochuMonth.vue?vue&type=script&lang=js&"
import style0 from "./daochuMonth.vue?vue&type=style&index=0&id=5d0a978c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0a978c",
  null
  
)

export default component.exports